import { render, staticRenderFns } from "./CampaignCreative.vue?vue&type=template&id=670d89eb&"
import script from "./CampaignCreative.vue?vue&type=script&lang=js&"
export * from "./CampaignCreative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports